import types from '../actions/types';
import {
    singleResultReducer,
    singleResultInitialState
} from './common/single-result';
import {
    multipleResultReducer,
    multipleResultInitialState
} from './common/multiple-results';
import {
    paginatedResultReducer,
    initialState
} from './common/paginated_results';
import {
    removeItem
} from './common/remove-item';

const initial_state = {
    availableStages: multipleResultInitialState,
    upcomingStage: singleResultInitialState,
    registerToAllStages: singleResultInitialState,
    stage: singleResultInitialState,
    stagesPaginated: initialState,
    stageParticipants: initialState,
    stageResults: initialState,

    registerToCustomStages: singleResultInitialState

}

export default function(state = initial_state, action) {
    switch (action.type) {
        case types.SUBMIT_STAGE.SUCCESS:
            return {
                ...state,
                stage: {
                    ...singleResultInitialState,
                    item: action.payload
                }
            };

        case types.ADMIN_UPDATE_STAGE_DISTANCE:
            return {
                ...state,
                stage: {
                    ...state.stage,
                    item: {
                        ...state.stage.item,
                        distances: buildDistancesList(state.stage.item.distances, action.payload.distance)
                    }

                }
            }
        case types.DELETE_DISTANCE.SUCCESS:

            return {
                ...state,
                stage: {
                    ...state.stage,
                    item: {
                        ...state.stage.item,
                        distances: removeDistance(state.stage.item.distances, action.payload.id)
                    }

                }
            }
        case types.DELETE_STAGE.SUCCESS:

            return {
                ...state,
                stages: {
                    ...state.stages,
                    items: removeItem(state.stages.items, action.payload.id)
                }

            }
        default:
            return {
                ...state,
                stage: singleResultReducer(state.stage, types.LOAD_STAGE, action),
                upcomingStage: singleResultReducer(state.upcomingStage, types.LOAD_UPCOMING_STAGE, action),
                registerToAllStages: singleResultReducer(state.registerToAllStages, types.REGISTRATION_TO_ALL, action),
                stages: singleResultReducer(state.upcomingStage, types.LOAD_UPCOMING_STAGE, action),
                availableStages: multipleResultReducer(state.availableStages, types.LOAD_STAGES, action),
                stagesPaginated: paginatedResultReducer(state.stagesPaginated, types.LOAD_STAGES_PAGINATED, action),
                stageParticipants: paginatedResultReducer(state.stageParticipants, types.LOAD_STAGE_PARTICIPANTS, action),
                stageResults: paginatedResultReducer(state.stageResults, types.LOAD_STAGE_RESULTS, action),
                registerToCustomStages: singleResultReducer(state.registerToCustomStages, types.REGISTRATION_TO_CUSTOM, action)
            };
    }
}



function removeDistance(distances, distanceToRemoveId) {
    let distancesReturn = [];
    distances.forEach(distance => {
        if (distance.id !== distanceToRemoveId) {
            distancesReturn.push(distance);
        }
    });
    return distancesReturn;
}


function buildDistancesList(distances, distanceToUpdate) {
    let found = false;
    distances = distances.map(distance => {
        if (distance.id === distanceToUpdate.id) {
            found = true;
            return distanceToUpdate;
        }
        return distance;
    });
    if (!found) {
        distances.push(distanceToUpdate);
    }
    return distances;
}



// WEBPACK FOOTER //
// ./src/js/reducers/stage.js